<template>
  <div>
    <b-modal
      ref="modal-tag-assign"
      size="lg"
      scrollable
      centered
      :hide-footer="true"
      @hide="hideModal"
    >
      <template #modal-title>
        <i class="fa fa-plus"></i> Atribuir Tag
      </template>

      <Forms
        ref="frmAssign"
        :title="''"
        :showClearButton="true"
        :showSaveButton="true"
        :showBackButton="true"
        :showTipFooter="false"
        v-on:Clear="onClear"
        v-on:Save="onSave"
        v-on:Back="hideModal"
      >
        <div class="form-group row">
          <div class="col-md-12">
            <label><small class="text-danger">*</small> Quadro CRM:</label>
            <NxSelect
              :key="'quadro-' + clearKey"
              ref="selectQuadro"
              v-model="form.quadroId.value"
              :options="quadroOptions"
              :multiple="true"
              id="selectQuadro"
              labelText=""
              placeholder="Selecione o(s) Quadro(s)"
              @update:value="handleQuadroChange"
            />
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <label>Coluna:</label>
            <NxSelect
              v-if="form.quadroId.value && form.quadroId.value.length === 1"
              :key="'coluna-' + clearKey"
              ref="selectColuna"
              v-model="form.colunaId.value"
              :options="colunaOptions"
              :multiple="false"
              id="selectColuna"
              labelText=""
              placeholder="Selecione a Coluna (opcional - deixe vazio para todas as colunas)"
              @update:value="handleColunaChange"
            />
            <NxSelect
              v-else
              :key="'coluna-disabled-' + clearKey"
              ref="selectColunaDisabled"
              v-model="form.colunaId.value"
              :options="[]"
              :multiple="false"
              :isDisabled="true"
              id="selectColunaDisabled"
              labelText=""
              :placeholder="form.quadroId.value && form.quadroId.value.length > 1 ? 'Selecione apenas um Quadro para escolher Colunas (ou deixe vazio para todas as colunas)' : 'Selecione primeiro um Quadro CRM'"
            />
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <label><small class="text-danger">*</small> Tag:</label>
            <NxSelectTag
              :key="'tag-' + clearKey"
              ref="selectTag"
              v-model="form.tagId.value"
              :onlyActive="true"
              :state="form.tagId.state"
              @update:value="handleTagChange"
              @clear-state="form.tagId.state = null"
            />
          </div>
        </div>
      </Forms>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Forms from '@/components/forms/Forms.vue'
import NxSelect from '@/components/nexum/components/selects/NxSelect.vue'
import NxSelectTag from '@/components/nexum/components/custom-selects/NxSelectTag.vue'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import TagQuadroColunaRepository from '@/shared/http/repositories/configurations/tag-quadro-coluna.js'

export default {
  name: 'TagAssignModal',
  mixins: [ActionsForm],
  components: {
    Forms,
    NxSelect,
    NxSelectTag
  },
  data () {
    return {
      form: {
        quadroId: {
          value: [],
          required: true,
          state: null
        },
        colunaId: {
          value: null,
          required: false,
          state: null
        },
        tagId: {
          value: null,
          required: true,
          state: null
        }
      },
      quadroOptions: [],
      colunaOptions: [],
      clearKey: 0 // Key para forçar re-render dos componentes
    }
  },
  created () {
    this.onLoadBoards()
  },
  watch: {
    'form.quadroId.value' (newVal, oldVal) {
      // Limpa a coluna quando muda o quadro
      if (newVal !== oldVal) {
        this.form.colunaId.value = null
        this.form.colunaId.state = null
        // Carrega colunas apenas quando exatamente 1 quadro é selecionado
        if (newVal && newVal.length === 1) {
          this.onLoadColumns(newVal)
        } else {
          this.colunaOptions = []
        }
      }
    }
  },
  methods: {
    showModal (data = null) {
      this.onClear()
      // Se houver dados, preenche o formulário
      if (data) {
        this.form.quadroId.value = data.quadroId
        this.form.colunaId.value = data.colunaId
        this.form.tagId.value = data.tagId
      }
      this.$refs['modal-tag-assign'].show()
    },
    hideModal () {
      this.$refs['modal-tag-assign'].hide()
      this.$nextTick(() => {
        this.onClear()
      })
    },
    onLoadBoards () {
      BoardRepository.Board_GetAll()
        .then((res) => {
          const activeBoards = res.data.content
            .filter((x) => x.id != null && !x.arquivado)
            .map((x) => ({
              value: x.id,
              text: x.nome
            }))
          this.quadroOptions = activeBoards
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Quadros', 'Erro')
          console.error(err)
        })
    },
    async onLoadColumns (boardIds) {
      if (!boardIds || !Array.isArray(boardIds) || boardIds.length !== 1) {
        this.colunaOptions = []
        return
      }

      const boardId = boardIds[0]
      try {
        loading.push()
        const response = await BoardRepositoryV2.Column_GetAllActive(boardId)
        const columns = response.data.content
          .filter((x) => x.id != null && x.inative !== true)
          .map((x) => ({
            value: x.id,
            text: x.nome
          }))
        this.colunaOptions = columns
      } catch (error) {
        toast.error('Não foi possível carregar a lista de Colunas', 'Erro')
        console.error(error)
        this.colunaOptions = []
      } finally {
        loading.pop()
      }
    },
    onClear () {
      // Usa $set para garantir reatividade
      this.$set(this.form.quadroId, 'value', [])
      this.$set(this.form.colunaId, 'value', null)
      this.$set(this.form.tagId, 'value', null)
      // Limpa os estados de validação
      this.$set(this.form.quadroId, 'state', null)
      this.$set(this.form.colunaId, 'state', null)
      this.$set(this.form.tagId, 'state', null)
      // Limpa opções de coluna
      this.colunaOptions = []
      // Incrementa a key para forçar re-render dos componentes
      this.clearKey++
      // Força atualização no próximo tick para garantir que os componentes reajam
      this.$nextTick(() => {
        // Tenta limpar os componentes diretamente se tiverem método clear ou reset
        if (this.$refs.selectQuadro && typeof this.$refs.selectQuadro.clear === 'function') {
          this.$refs.selectQuadro.clear()
        }
        if (this.$refs.selectColuna && typeof this.$refs.selectColuna.clear === 'function') {
          this.$refs.selectColuna.clear()
        }
        if (this.$refs.selectTag && typeof this.$refs.selectTag.clear === 'function') {
          this.$refs.selectTag.clear()
        }
        // Emite evento para limpar os selects se necessário
        this.$root.$emit('clearForm')
      })
    },
    handleQuadroChange (val) {
      this.form.quadroId.value = val || []
      if (val && val.length > 0) {
        this.form.quadroId.state = null
      }
      // Limpa a coluna quando muda o quadro
      this.form.colunaId.value = null
      this.form.colunaId.state = null
      // Se tiver mais de 1 quadro, não carrega colunas
      if (val && val.length === 1) {
        this.onLoadColumns(val)
      } else {
        this.colunaOptions = []
      }
    },
    handleColunaChange (val) {
      this.form.colunaId.value = val || null
      if (val) {
        this.form.colunaId.state = null
      }
    },
    handleTagChange (val) {
      this.form.tagId.value = val
      if (val) {
        this.form.tagId.state = null
      }
    },
    onSave () {
      let hasError = false

      // Valida todos os campos obrigatórios e marca os inválidos
      if (!this.form.quadroId.value || !Array.isArray(this.form.quadroId.value) || this.form.quadroId.value.length === 0) {
        this.$set(this.form.quadroId, 'state', false)
        hasError = true
      } else {
        this.$set(this.form.quadroId, 'state', null)
      }

      // Coluna é opcional - se não selecionar, aplica em todas as colunas
      this.$set(this.form.colunaId, 'state', null)

      if (!this.form.tagId.value) {
        this.$set(this.form.tagId, 'state', false)
        hasError = true
      } else {
        this.$set(this.form.tagId, 'state', null)
      }

      if (hasError) {
        toast.warning('Preencha os campos obrigatórios', 'Erro')
        return
      }

      // Prepara os dados para enviar ao backend
      const promises = []

      // Processa cada quadro selecionado
      for (const boardId of this.form.quadroId.value) {
        let boardColumnId = null

        // Se tem apenas 1 quadro e tem coluna selecionada, usa a coluna
        if (this.form.quadroId.value.length === 1 && this.form.colunaId.value) {
          boardColumnId = this.form.colunaId.value
        }
        // Caso contrário, boardColumnId fica null (todas as colunas)

        const data = {
          tagId: this.form.tagId.value,
          boardId: boardId,
          boardColumnId: boardColumnId // null = todas as colunas, valor = coluna específica
        }
        promises.push(TagQuadroColunaRepository.Create(data))
      }

      loading.push()
      Promise.all(promises)
        .then((responses) => {
          loading.pop()
          const count = responses.length
          toast.success(`${count} associação(ões) de tag criada(s) com sucesso!`)
          this.hideModal()
          this.$emit('assigned')
        })
        .catch((err) => {
          loading.pop()
          // O interceptor do axios retorna error.response diretamente
          // Então err já é o response, então err.data contém { errors: [...] }
          if (err && err.data && err.data.errors &&
              Array.isArray(err.data.errors) && err.data.errors.length > 0) {
            const errorMessage = err.data.errors[0].message
            if (errorMessage) {
              // Exibe em amarelo (warning) igual aos campos não preenchidos
              toast.warning(errorMessage, 'Atenção')
              return // Importante: retorna para não chamar onException
            }
          }
          // Se não encontrou mensagem específica, usa o tratamento padrão
          this.onException(err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/tag/components/assign/TagAssignModal.vue